// The corner RESIZE handle of a home widget frame (components/HomeWidgetFrame.js
// mounts it as its `HomeWidgetResizeHandle` child; DESIGN-WL-HOME-WIDTH-RESIZE-1,
// HOME_WIDGETS_SPEC §1 dated line + §6).
//
// A square icon button (1:1 — Nika: "all icon buttons should have 1/1 aspect
// ratio") at the card's bottom-right corner, over the card (an overlay:
// showing it moves nothing). The CARD reveals it — hover, focus-within, edit
// mode — through its `.widget-resize-handle` rules; at rest it is invisible
// and takes no pointer, so a tap on the corner still opens the card.
//
// Drag: pointer down captures the pointer on the handle, so every move and the
// release land here (no document listener); the frame's dashed outline
// (`WidgetResizeGhost`) shows the size the release will give; Escape on the
// focused handle cancels (functions/homeWidgetResize.js). Arrows on the
// focused handle step the size. Focusable only in edit mode — outside it the
// handle is a pointer affordance; the keyboard path there is Shift + an arrow.
export const HomeWidgetResizeHandle = {
  extends: 'IconButton',
  class: 'gs-no-drag widget-resize-handle',
  hide: (el, s) => el.call('homeWidgetIsApp', s),
  position: 'absolute',
  right: 'X',
  bottom: 'X',
  zIndex: '4',
  boxSize: 'iconLg',
  minWidth: 'iconLg',
  minHeight: 'iconLg',
  padding: '0',
  round: 'radiusControl',
  theme: 'layer',
  color: 'caption',
  border: 'none',
  align: 'center center',
  cursor: 'nwse-resize',
  touchAction: 'none',
  opacity: '0',
  pointerEvents: 'none',
  translate: '0 var(--spacing-X)',
  transition: 'opacity A defaultBezier, translate A defaultBezier',
  ':hover': { background: 'selected', color: 'title' },
  ':active': { background: 'selected', color: 'title' },
  tabindex: (el, s) => (s.root._homeCustomizeMode ? '0' : '-1'),
  title: (el, s) => el.call('homeWidgetResizeTitle', s),
  'aria-label': (el) => el.call('polyglot', 'workspace.widget.size.label'),
  'aria-keyshortcuts': 'Shift+ArrowLeft Shift+ArrowRight Shift+ArrowUp Shift+ArrowDown',
  Icon: { name: 'arrowAngleDownRight', boxSize: 'iconSm' },
  onPointerdown: (e, el, s) => el.call('homeWidgetResizeStart', e, s),
  onPointermove: (e, el, s) => el.call('homeWidgetResizeMove', e, s),
  onPointerup: (e, el, s) => el.call('homeWidgetResizeEnd', e, s, false),
  onPointercancel: (e, el, s) => el.call('homeWidgetResizeEnd', e, s, true),
  onLostpointercapture: (e, el, s) => el.call('homeWidgetResizeEnd', e, s, true),
  // the card never also opens from a press on its handle
  onClick: (e) => {
    e.stopPropagation()
    e.preventDefault()
  },
  onKeydown: (e, el, s) => el.call('homeWidgetResizeKey', e, s)
}
